export const GET_PRICINGS = "GET_PRICINGS";
export const GET_PRICING_BY_ID = "GET_PRICING_BY_ID";
export const UPDATE_PRICING = "UPDATE_PRICING";
export const DELETE_PRICING = "DELETE_PRICING";
export const CREATE_PRICING = "CREATE_PRICING";
